// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__HTUd_","log":"ModalInventoryLogs_log__3uItt","date":"ModalInventoryLogs_date__2UXRz","userName":"ModalInventoryLogs_userName__1leqm"};